import type { FunctionComponent } from 'react';

import type { ApplicationEntity } from './types';

import * as styles from './Application.module.less';

type ApplicationProps = Pick<ApplicationEntity, 'text'>;

export const Application: FunctionComponent<ApplicationProps> = ({ text }) => {
  return <span className={styles.fontWeightBold}>{text}</span>;
};
